import { defineGenericReactComponent } from "./angular"
import { defineReactWrapperDirective } from "./reactDirective"

export function setupReact(module: ng.IModule) {

    // Defines the om-react directive, which can be set on any HTML element to include a React component
    // See reactDirective.ts
    module.directive("omReact", defineReactWrapperDirective)

    // Defines the omnia-react-component component, which can be used as a generic wrapper
    // for a React component
    // This is used when starting React components using the startComponent() functoin
    module.directive("omniaReactComponent", defineGenericReactComponent)

}
